import React, { useEffect, useState } from 'react'
import { Pagination, Card, Box, Tab, Typography } from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import RegulatoryBodyDrawer from '../../Components/Governance/RegulatoryBodyDrawer'
import RegulatoryTable from '../../Components/Governance/Components/RegulatoryTable'
import { useLocation, useNavigate, useParams } from 'react-router'
import * as RoutePath from '../../Entities/RoutePath'
import { lawTypes } from 'src/Entities/Governance'
import SelectRegulation from 'src/Components/Onboarding/SelectRegulation'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { useOnboardingStore } from '../Onboarding/Store/OnboardingStore'
import { getComplianceStatusTabCount, getCompSeedByRegulationId, getSelectedCompliance, setIsSelectCompliance, submitSeedCompliance, useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import { cn } from 'src/lib/utils'
import { MENU_TYPE_GOVERNANCE_SETUP } from 'src/Entities/MainContainerTypes'
import SelectCompliance from './SelectCompliance'
import { STATUS_ENUMS, TAB_COUNT_KEY } from 'src/Entities/StatusEnums'
const GovernanceSetup = ({ type }) => {
    const [ data, setData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const selectOrgRegulation = useGovernanceStore(state => state.selectOrgRegulation)
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const status = +queryParams.get('status')
    const regulation = +queryParams.get('regulation')
    const frequency = +queryParams.get('frequency')
    const regulationId = +queryParams.get('regulationId')
    const { mandateType, regulationName } = useParams()
    const [ value, setValue ] = useState()
    const [ editState, setEditState ] = useState({ right: false })
    const [ editNode, setEditNode ] = useState({})
    const handleEditClick = (item) => {
        if (regulation) {
            navigate(routePath + '/' + mandateType + '/' + regulationName + '/Edit compliance' + '?bodyType=' + bodyType + '&regulation=' + 1 + '&regulationId=' + regulationId + '&complianceId=' + item.id)
        } else {
            setEditNode(item)
            setEditState({ right: true })
        }
    }
    const getSelectedRegulation = useGovernanceStore(state => state.getSelectedRegulations)
    const { selectedRegulations, getAllRegulationsBasedType } = useGovernanceStore()
    const { getAllCompliance, complianceList } = useCompStore()
    const selectedSeedData = useCompStore((state) => state.selectedSeededCompDataList)
    const tabCount = useCompStore((state) => state.tabCount)

    const { getOrgRegulation } = useOnboardingStore()
    const getOrgRegData = useOnboardingStore(state => state.getOrgRegulationData)
    const routePath = '/GRC' + (type === MENU_TYPE_GOVERNANCE_SETUP ? RoutePath.GOVERNANCE.URI : RoutePath.GOVERNANCE.COMPLIANCE) + '-' + RoutePath.GOVERNANCE.SETUP
    const [ tableBody, setTableBody ] = useState([])

    const [ isSelectRegulation, setIsSelectRegulation ] = useState(false)
    const [ regulationListData, setRegulationListData ] = useState([])
    const [ seedComplianceListData, setseedComplianceListData ] = useState([])
    const [ editData, setEditData ] = useState([])
    const [ compEditData, setCompEditData ] = useState([])
    // const [ editCompData, setEditCompData ] = useState([])
    const orgId = localStorage.getItem('orgId')
    const userId = localStorage.getItem('userId')
    const handleApplyRegulationList = async () => {
        setIsSelectRegulation(false)
        await selectOrgRegulation(editData, orgId, userId)
        getOrgRegulation(orgId, userId, bodyType)
        getSelectedRegulation(orgId, bodyType)
    }
    const handleApplyComplianceSeeding = async () => {
        setIsSelectCompliance(false)
        await submitSeedCompliance(compEditData, orgId, userId, regulationId)
        getAllCompliance(regulationId, frequency, orgId, new Date(), null, null, status)
        getComplianceStatusTabCount(orgId, regulationId)
        getCompSeedByRegulationId(regulationId)

        getSelectedCompliance(orgId, regulationId)
    }

    const handleCancelRegulationList = () => {
        setRegulationListData(regulationListData?.map((el) => {
            return { ...el, isChecked: false }
        }))
        setIsSelectRegulation(false)
    }
    const handleCancelComplianceList = () => {
        setseedComplianceListData(seedComplianceListData?.map((el) => {
            return { ...el, isChecked: false }
        }))
        setIsSelectCompliance(false)
    }
    const formatCount = count => String(count).padStart(2, '0')
    useEffect(() => {
        if (regulation) {
            getComplianceStatusTabCount(orgId, regulationId)
            setCurrentPage(1)
            setTableBody([])
            getAllCompliance(regulationId, frequency, orgId, new Date(), null, null, status)
            getCompSeedByRegulationId(regulationId)
            getSelectedCompliance(orgId, regulationId)
        } else {
            setCurrentPage(1)
            setTableBody([])
            getAllRegulationsBasedType(1)
            getOrgRegulation(orgId, userId, bodyType)
            getSelectedRegulation(orgId, bodyType)
        }

        if (!bodyType || !status) {
            navigate(routePath + '?bodyType=1' + '&status=1')
        }
    }, [location])
    useEffect(() => {
        if (regulation) {
            setData(complianceList)
        } else {
            if (getOrgRegData?.length > 0) {
                setData(getOrgRegData)
            }
        }
    }, [ getOrgRegData, complianceList ])

    useEffect(() => {
        setRegulationListData(selectedRegulations)
    }, [selectedRegulations])
    useEffect(() => {
        setseedComplianceListData(selectedSeedData)
    }, [selectedSeedData])
    // eslint-disable-next-line no-unused-vars
    const [ totalComp, setTotalComp ] = useState(0)
    const [ activeCount, setActiveCount ] = useState(0)
    const [ inactiveCount, setInactiveCount ] = useState(0)
    useEffect(() => {
        setValue(+frequency || bodyType)
        let finalData = []
        const separatedDatas = Object.groupBy(data || [], ({ status, complianceStatus }) => {
            if (regulation) {
                return complianceStatus
            } else {
                return status
            }
        })
        if (regulation) {
            finalData = data
        } else {
            finalData = separatedDatas[+status] || []
            if (location.pathname.includes('compliance-setup')) {
                setTotalComp(finalData.reduce((sum, item) => sum + item.total, 0))
            } else {
                setTotalComp(data?.length)
            }
        }
        if (!regulation) {
            setActiveCount(separatedDatas[+STATUS_ENUMS.Active]?.length)
            setInactiveCount(separatedDatas[+STATUS_ENUMS.Inactive]?.length)
        }
        setTableBody(finalData)
    }, [data])
    const rowsPerPage = 5
    const [ totalPages, setTotalPages ] = useState(Math.ceil(tableBody?.length / rowsPerPage))
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    const navigate = useNavigate()
    const handleChange = (event, newEvent) => {
        setValue(newEvent)
        if (regulation) {
            navigate(routePath + '/' + mandateType + '/' + regulationName + '?bodyType=' + bodyType + '&regulation=' + regulation + '&status=' + status + '&frequency=' + newEvent + '&regulationId=' + regulationId)
        } else {
            navigate(routePath + '?bodyType=' + newEvent + '&status=' + status)
        }
        setCurrentPage(1)
    }

    const handleStatusToggle = (status) => {
        if (regulation) {
            navigate(routePath + '/' + mandateType + '/' + regulationName + '?bodyType=' + bodyType + '&regulation=' + regulation + '&status=' + status + '&frequency=1' + '&regulationId=' + regulationId)
        } else {
            navigate(routePath + '?bodyType=' + bodyType + '&status=' + status)
        }
        setCurrentPage(1)
    }
    const handleDrawSubmit = (currentNode, editNode, childNodeCount) => {
        const finalNode = (data?.map((item) => {
            if (item.id === editNode.id) {
                return editNode
            }
            return item
        }))
        setData(finalNode)
    }
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })

    return (
        <>
            <div className=" flex flex-col flex-grow gap-1 p-5 px-5 h-[100%] !overflow-auto ">
                {!location.search.includes('regulationId') && <div style={{ width: '100%' }} className="my-2 flex-shrink-0">
                    <div style={{ display: 'flex', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '100px', height: '40px', width: 'fit-content', padding: '0', overflow: 'hidden' }}>
                        {(!regulation ? lawTypes : []).map((item) => {
                            return (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 20px',
                                            margin: '5px',
                                            borderRadius: '100px',
                                            cursor: 'pointer',
                                            backgroundColor: value + '' === item.value + '' ? 'hsl(var(--primary))' : '',
                                            color: value + '' === item.value + '' ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                            transition: 'background-color 0.3s, color 0.3s'
                                        }}
                                        className={cn(value + '' === item.value + '' ? '' : '!font-regular', 'text-h5')}
                                        onClick={() => handleChange(null, item.value)} >{item.label}</div>
                                </>
                            )
                        })}
                    </div>
                </div>}
                <Card className={cn(regulation ? 'h-full' : 'h-[93%]', 'flex flex-col justify-between !overflow-scroll flex-shrink-0')}>
                    <div className='w-[100%] h-[75%] flex-grow'>
                        <Box sx={{ width: '100%', height: '100%' }}>
                            <TabContext value={'' + status}>
                                <Box sx={{ borderBottom: 2, paddingLeft: '20px' }} className=' flex justify-between items-center text-primary-foreground'>
                                    <TabList
                                        sx={{
                                            '& .MuiTabs-indicator': { background: 'hsl(var(--primary))' },
                                            display: 'flex',
                                            alignItems: 'center',
                                            transform: 'translateY(2px)'
                                        }}
                                    >
                                        <Tab label={<div className='flex gap-1 items-center'><div className='!text-h4'>Active</div><div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', fontSize: '12px', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {!regulation ? activeCount ?? 0 : tabCount?.[TAB_COUNT_KEY.ACTIVE] ?? 0}
                                        </div></div>} value={'' + STATUS_ENUMS.Active} onClick={() => handleStatusToggle('1')} sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' }, padding: '0px' }} />
                                        <Tab label={<div className='flex gap-1 items-center'><div className='!text-h4'>In Active</div><div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', fontSize: '12px', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {!regulation ? inactiveCount ?? 0 : tabCount?.[TAB_COUNT_KEY.INACTIVE] ?? 0}
                                        </div></div>} value={'' + STATUS_ENUMS.Inactive} onClick={() => handleStatusToggle('2')} sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' }, padding: '0px' }} />
                                        {regulation && <Tab label={<div className='flex gap-1 items-center'><div className='!text-h4'>Unassigned</div><div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', fontSize: '12px', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {tabCount?.[TAB_COUNT_KEY.UNASSIGNED] || 0}
                                        </div></div>} value={'' + STATUS_ENUMS.Draft} onClick={() => handleStatusToggle('30')} sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' }, padding: '0px' }} />}
                                    </TabList>
                                    {
                                        !regulation && <p className='text-muted text-h4'>Total {location.pathname.includes('compliance-setup') ? 'Compliance' : 'Regulation'}: <span className='text-primary !font-[500] text-h4'>{totalComp < 10 ? '0' + totalComp : totalComp}</span></p>
                                    }                                </Box>
                            </TabContext>
                            <RegulatoryTable setTotalPages={setTotalPages} type={type} routePath={routePath} setEntries={setEntries} regulation={regulation} setIsSelectRegulation={setIsSelectRegulation} regulationTableData={tableBody} handleEditClick={handleEditClick} currentPage={currentPage} />
                        </Box>
                    </div>
                    {totalPages > 0 && <div className="border-t-2 relative p-4 z-10 h-[15%] bg-card border-t-primary-foreground py-2 flex items-center justify-between mt-2 mx-2">
                        <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                        />
                    </div>}
                </Card>
            </div>
            <SelectRegulation editData={editData} setEditData={setEditData} isSelectRegulation={isSelectRegulation} setIsSelectRegulation={setIsSelectRegulation} formatCount={formatCount} setRegulationListData={setRegulationListData} regulationListData={regulationListData} handleApplyRegulationList={handleApplyRegulationList} handleCancelRegulationList={handleCancelRegulationList} />
            <SelectCompliance editData={compEditData} setEditData={setCompEditData} formatCount={formatCount} complianceListData={seedComplianceListData} handleApplyComplianceSeeding={handleApplyComplianceSeeding} handleCancelRegulationList={handleCancelComplianceList} />
            <RegulatoryBodyDrawer
                setEditState={setEditState}
                editState={editState}
                tableBody={tableBody}
                setTableBody={setTableBody}
                getState={editNode}
                onEdit={handleDrawSubmit}
                setEditNodes={setEditNode}
            />
        </>
    )
}

export default GovernanceSetup
